import { Component, Inject, OnInit } from '@angular/core';
import { MAT_SNACK_BAR_DATA } from '@angular/material/snack-bar';

@Component({
  selector: 'common-connection',
  templateUrl: './connection.component.html',
  styleUrls: ['./connection.component.scss']
})
export class ConnectionComponent implements OnInit {
  showConnectionMessage: boolean;
  // tslint:disable-next-line: no-any
  constructor(@Inject(MAT_SNACK_BAR_DATA) public data: any) {}

  ngOnInit() {
    this.showConnectionMessage = true;
  }

  closeConnectionMessage() {
    this.showConnectionMessage = false;
  }
}
